import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {MainLayout} from '../../containers/Common';
import MemberList from './MemberList';
import MemberSearch from './MemberSearch';

const Member = () => {
  const [urlSearchParams] = useSearchParams();
  const initialSearchParams = {};
  ['meeting', 'status', 'response_status', 'state', 'special_program', 'evening_program', 'accompany_program', 'parking_pass'].forEach((name) => {
    const value = urlSearchParams.get(name);
    if (value) {
      initialSearchParams[name] = ['meeting', 'status', 'state', 'special_program', 'evening_program', 'accompany_program', 'parking_pass'].includes(name)
        ? Number(value)
        : value;
    }
  });
  const [searchParams, setSearchParams] = useState(initialSearchParams);

  const breadCrumbs = [
    {key: 'home', name: 'Gesamtübersicht ', url: '/'}
  ];

  return <MainLayout breadCrumbs={breadCrumbs}>
    <MemberSearch searchParams={searchParams} setSearchParams={setSearchParams}/>
    {searchParams.meeting && <MemberList searchParams={searchParams}/>}
  </MainLayout>;
}

export default Member;
